import React from "react";
import { Link } from "react-router-dom";

const NoPurchases = () => (
  <>
    <div className="contentPage__headingDiv">
      <h1>Purchase History</h1>
      <h6>No purchases to display.</h6>
    </div>
    <div className="purchaseHistoryBlock" style={{ position: "relative" }}>
      <div className="purchaseHistory__signin__register__button__container">
        <p className="purchases__message">
          Try browsing our extensive <Link to="/catalog">course catalog</Link>,
          or <Link to="/contact-us">contact us</Link>.
        </p>
      </div>
    </div>
  </>
);

export default NoPurchases;
